<!--  COMPONENT IS OBSOLETE AND CAN BE REMOVED ONCE THERE ARE NO ACTIVE OLD REQUEST OBJECTS  -->
@if (!hasSubmitted[request.Id]) {
  @if (lookups$ | async; as lookups) {
    <div class="container">
      @if (stages$ | async; as stages) {
        <ol class="progress-list w-100">
          @for (stage of stages; track stage; let indexOfStage = $index) {
            @if (!!stage.show) {
              <li [ngClass]="{'success': stage.isComplete, 'active': stage.isActive}">
                <button type="button" (click)="save(request, 0, indexOfStage)">
                  <span class="progress-indicator"></span>
                  <span class="sr-only">{{stage.Name}}</span>
                </button>
                <span class="progress-label pointer" (click)="save(request, 0, indexOfStage)">{{stage.Name}}</span>
              </li>
            }
          }
        </ol>
      }
      <form class="p-3" name="globalCreditTransfer" #f="ngForm">
        @if (stages[0].isActive) {
          <div class="form-row">
            <div class="col-auto overflow-hidden dropdown-container">
              <label class="mb-0 col-form-label-sm" for="univSelect">Choose a university<span class="text-danger">*</span></label>
              <select class="form-select form-select-sm mb-1" id="univSelect" name="HostUniversity" [(ngModel)]="request.HostUniversity"
                (change)="transferCredits.university$.next($event.target.value)" (blur)="save(request, 0, -1)">
                @for (uni of lookups.univOptionsList; track uni) {
                  <option [value]="uni.Value">
                    {{uni.Key}}
                  </option>
                }
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          @if (request.HostUniversity=='other') {
            <div class="form-row">
              <div class="col-sm-10">
                <input class="form-control form-control-sm mb-1" type="text" placeholder="University Name" id="uniName" name="uniName"
                  [(ngModel)]="request.otherHostUniversity" (blur)="save(request, 0, -1)">
                </div>
              </div>
            }
            <div class="form-row">
              <div class="col-auto overflow-hidden dropdown-container">
                <label class="mb-0 col-form-label-sm" for="termSelect">Which term?<span class="text-danger">*</span></label>
                <select class="form-select form-select-sm mb-1" id="termSelect" name="Term" [(ngModel)]="request.Term" (blur)="save(request, 0, -1)">
                  @for (term of lookups.termsOptionsList; track term) {
                    <option [value]="term.Key">
                      {{term.Value}}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (stages[1].isActive) {
            @if (request.Status == 'Draft' || !!!request.Status) {
              @if (transferCredits.approvedClasses$ | async; as approvedClasses) {
                <div class="form-row">
                  @if (!!approvedClasses?.options?.length) {
                    <div class="col-sm-10 overflow-hidden dropdown-container">
                      <label class="mb-0 col-form-label-sm" for="classSelect">Commonly requested</label>
                      <select class="form-select form-select-sm mb-1" id="classSelect" name="approvedClass" [(ngModel)]="request.approvedClass"
                        (change)="changeApprovedClass($event.target.value, approvedClasses.dtos)" (blur)="save(request, 0, -1)">
                        @for (option of approvedClasses.options; track option) {
                          <option [value]="option.Value">
                            {{option.Key}}
                          </option>
                        }
                      </select>
                    </div>
                  }
                </div>
              }
            }
            <div class="form-row">
              <div class="col-sm-10">
                <label class="mb-0 col-form-label-sm" for="courseNumber">Course Number<span class="text-danger">*</span></label>
                <input class="form-control form-control-sm mb-1" type="text" placeholder="123456" id="courseNumber" name="courseNumber"
                  [(ngModel)]="request.HostCourseNumber" (blur)="save(request, 0, -1)">
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-10">
                  <label class="mb-0 col-form-label-sm" for="courseName">Course Name<span class="text-danger">*</span></label>
                  <input class="form-control form-control-sm mb-1" type="text" placeholder="Course name" id="courseName" name="courseName"
                    [(ngModel)]="request.HostCourseName" (blur)="save(request, 0, -1)">
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-sm-10">
                    <label class="mb-0 col-form-label-sm" for="courseCredits">Credits<span class="text-danger">*</span></label>
                    <input class="form-control form-control-sm mb-1" type="number" placeholder="0" id="courseCredits" name="courseCredits"
                      [(ngModel)]="request.HostCreditHours" (blur)="save(request, 0, -1)">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group ml-1">
                      <label class="mb-0 col-form-label-sm" for="syllabusUpload">Syllabus<span class="text-danger">*</span></label>
                      @if (request.SyllabusFilename != '' && !!request.SyllabusFilename) {
                        <button class="btn btn-link btn-sm ms-1 mb-1" (click)="transferCredits.openSyllabus(request.Id, request.SyllabusFilename)">{{request.SyllabusFilename}}</button>
                      }
                      <input type="file" class="form-control-file form-control-sm" id="syllabusUpload" name="syllabusUpload"
                        [(ngModel)]="request.filename" (change)="uploadFile($event)"
                        accept=".pdf,.docx,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf">
                        @if (uploadError[request.Id]) {
                          <div class="mb-0 col-form-label-sm text-warning">There was a problem uploading your file</div>
                        }
                        @if (uploadFileSizeError[request.Id]) {
                          <div class="mb-0 col-form-label-sm text-warning">
                            There was a problem uploading your file. Your file is too large, please limit to less than 4MB
                          </div>
                        }
                        @if (uploadSuccess[request.Id]) {
                          <div class="mb-0 col-form-label-sm text-success">Your file has been uploaded</div>
                        }
                      </div>
                    </div>
                  }
                  @if (stages[2].isActive) {
                    <div class="form-row">
                      <div class="col-auto overflow-hidden dropdown-container">
                        <label class="mb-0 col-form-label-sm" for="uncCourseSelect">UNC Equivalent<span class="text-danger">*</span></label>
                        <select class="form-select form-select-sm mb-1" id="uncCourseSelect" name="UncCourse"
                          [(ngModel)]="request.UncCourse" (change)="setEmphasisTab(request)" (blur)="save(request, 0, -1)">
                          @for (course of lookups.courseOptionsList; track course) {
                            <option [value]="course.Value">
                              {{course.Key}}
                            </option>
                          }
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>
                    @if (request.UncCourse =='other') {
                      <div class="form-row">
                        <div class="col-sm-10">
                          <input class="form-control form-control-sm mb-1" type="text" placeholder="Other Course Name" id="otherUncCourse" name="otherUncCourse"
                            [(ngModel)]="request.otherUncCourse" (blur)="save(request, 0, -1)">
                          </div>
                        </div>
                      }
                      <div class="form-row">
                        <div class="col-sm-10">
                          <label class="mb-0 col-form-label-sm" for="uncCourseHours">UNC Requested Credits<span class="text-danger">*</span></label>
                          <input class="form-control form-control-sm mb-1" type="number" placeholder="0" id="uncCourseHours" name="uncCourseHours"
                            [(ngModel)]="request.UncCourseHours" (blur)="save(request, 0, -1)">
                          </div>
                        </div>
                        @if (request.UncCourse=='General Education') {
                          <div class="form-row">
                            <div class="col-sm-10 mt-1">
                              <div class="card">
                                <div class="card-body">
                                  For a General Education requirement, we need to know a little more about the class you want to take.
                                  <div class="form-row">
                                    <div class="col-auto overflow-hidden dropdown-container">
                                      <label class="mb-0 col-form-label-sm" for="geRequirementSelect">Requested General Education Type<span class="text-danger">*</span></label>
                                      <select class="form-select form-select-sm mb-1" id="geRequirementSelect" name="GeRequirement"
                                        [(ngModel)]="request.GeRequirement" (blur)="save(request, 0, -1)">
                                        @for (gr of lookups.geOptionsList; track gr) {
                                          <option [value]="gr.Value">
                                            {{gr.Key}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="col-sm-10 form-check form-check-inline">
                                      <input class="form-check-input" type="checkbox" id="finalExam" name="finalExam"
                                        value="request.HasFinalExam" [(ngModel)]="request.HasFinalExam" (blur)="save(request, 0, -1)">
                                        <label class="form-check-label col-form-label-sm" for="finalExam">Is there a final exam for this class?</label>
                                      </div>
                                    </div>
                                    <div class="form-row">
                                      <div class="col-sm-10 form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="hasWrittenWork"
                                          name="hasWrittenWork" value="request.HasWrittenWork" [(ngModel)]="request.HasWrittenWork" (blur)="save(request, 0, -1)">
                                          <label class="form-check-label col-form-label-sm" for="hasWrittenWork">Does the class require 10 pages of written work and/or 3000 words?</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                          @if (stages[3].isActive && stages[3].show) {
                            <div class="form-row">
                              <div class="col-sm-10">
                                <p class="mb-0 col-form-label-sm" for="syllabusUpload">Emphasis Credit?</p>
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" [(ngModel)]="request.HasEmphasis"
                                    name="hasAreaOfEmphasis" id="hasAreaOfEmphasis1" [value]="true">
                                    <label class="form-check-label  col-form-label-sm" for="HasAreaOfEmphasis1">Yes</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" [(ngModel)]="request.HasEmphasis" name="hasAreaOfEmphasis" id="hasAreaOfEmphasis2" (click)="clearEmphasisFields(request)" [value]="false">
                                    <label class="form-check-label col-form-label-sm" for="HasAreaOfEmphasis2">No</label>
                                  </div>
                                </div>
                              </div>
                              @if (request.HasEmphasis) {
                                <div class="form-row">
                                  <div class="col-auto overflow-hidden dropdown-container">
                                    <label class="mb-0 col-form-label-sm" for="areaOfEmphasis">Area<span class="text-danger">*</span></label>
                                    <select class="form-select form-select-sm mb-1" id="areaOfEmphasis" name="areaOfEmphasis"
                                      [(ngModel)]="request.AreaOfEmphasis" (blur)="save(request, 0, -1)">
                                      @for (emphasis of lookups.emphasisOptionsList; track emphasis) {
                                        <option [value]="emphasis.Value">
                                          {{emphasis.Key}}
                                        </option>
                                      }
                                      @if (!isCurrentEmphasis) {
                                        <option [value]="request.AreaOfEmphasis" hidden disabled>
                                          {{request.AreaOfEmphasis}}
                                        </option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                @if (discontinuedEmphasis.includes(request.AreaOfEmphasis)) {
                                  <div class="alert alert-warning">
                                    This AOE is being discontinued. Only students who have previously declared this AOE should select this option.
                                  </div>
                                }
                                <div class="form-row">
                                  <div class="col-sm-10">
                                    <label class="mb-0 col-form-label-sm" for="uncEquivalentToSubstitute">AOE Equivalent Course<span class="text-danger">*</span></label>
                                    <input class="form-control form-control-sm mb-1" type="text" placeholder="e.g. BUSI 508 for Investments" id="uncEquivalentToSubstitute" name="uncEquivalentToSubstitute"
                                      [(ngModel)]="request.UncEquivalentToSubstitute" (blur)="save(request, 0, -1)">
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="col-auto overflow-hidden dropdown-container">
                                      <label class="mb-0 col-form-label-sm" for="anticipatedGraduation">Anticipated Graduation Date<span class="text-danger">*</span></label>
                                      <select class="form-select form-select-sm mb-1" id="anticipatedGraduation"
                                        [(ngModel)]="request.AnticipatedGraduation" name="anticipatedGraduation" (blur)="save(request, 0, -1)">
                                        @for (date of lookups.gradDateOptionsList; track date) {
                                          <option [value]="date.Value">
                                            {{date.Key}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="col-sm-10">
                                      <div class="d-flex justify-content-between">
                                        <label class="mb-0 col-form-label-sm" for="AoeJustification">Justification<span class="text-danger">*</span></label>
                                        <small class="fst-italic">{{request.AoeJustification? request.AoeJustification.length : 0}}/{{maxNoJustificationChars}}</small>
                                      </div>
                                      <textarea class="form-control form-control-sm mb-1" id="AoeJustification"
                                        name="AoeJustification" [(ngModel)]="request.AoeJustification" (blur)="save(request, 0, -1)" [attr.maxlength]="maxNoJustificationChars">
                                      </textarea>
                                    </div>
                                  </div>
                                }
                              }
                              @if (stages[4].isActive) {
                                @if (!request.isValid) {
                                  <div class="alert alert-warning" role="alert">
                                    Your request has been saved as draft. To submit this request you need to complete the required fields.
                                  </div>
                                }
                                @if (!request.isValid) {
                                  <ul>
                                    @for (error of request.errorArray; track error) {
                                      <li>
                                        <button class="btn btn-link btn-error" (click)="stageNumber$.next(error.stage)">{{error.text}}</button>
                                      </li>
                                    }
                                  </ul>
                                }
                                @if (request.isValid) {
                                  <div class="card">
                                    <div class="card-body">
                                      @if (hasSubmitError) {
                                        <div class="alert alert-warning" role="alert">
                                          <p>
                                            There was a problem submitting your request. Please try again.
                                          </p>
                                          <p>
                                            If the problem persists, please contact the IT Service Desk at itservicedesk&#64;kenan-flagler.unc.edu
                                          </p>
                                        </div>
                                      }
                                      <p>
                                        By submitting this request, I understand that course requests are reviewed on an individual basis. Previous approvals of this course do not guarantee that it will be approved for the same
                                        time of credit in this instance, as courses are subject to change in content each semester at Kenan-Flagler and at my host institution. I understand that if I am requesting credit for a
                                        business core class or direct business elective equivalency course, this requires Kenan-Flagler faculty approval, and for this to be approved, the content must match by 90% to the
                                        equivalent Kenan-Flagler course.
                                      </p>
                                      <p>
                                        Additionally, by submitting this request I am certifying that:
                                      </p>
                                      <ul>
                                        <li>The class I am submitting for review is not an online only course </li>
                                        <li>The class I am submitting for review is not a pass/fail course and I will receive a letter or number grade from my host institution </li>
                                      </ul>
                                    </div>
                                  </div>
                                }
                              }
                            </form>
                          </div>
                        }
                        <div class="d-flex flex-row justify-content-center mt-3">
                          @if (stageNumber$.value > 0) {
                            <button type="button" [disabled]="isPrevLoading" class="btn btn-primary me-1"
                              (click)="save(request, -1, -1)">
                              << Previous
                              @if (isPrevLoading) {
                                <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                              }
                            </button>
                          }
                          @if (stageNumber$.value < 4) {
                            <button type="button" [disabled]="isNextLoading" class="btn btn-primary"
                              (click)="save(request, 1, -1)">
                              Next >>
                              @if (isNextLoading) {
                                <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                              }
                            </button>
                          }
                          @if (stageNumber$.value == 4) {
                            <button type="button" [disabled]="!request.isValid" class="btn btn-primary"
                              (click)="submit(request)">
                              Submit
                              @if (isSubmitting) {
                                <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                              }
                            </button>
                          }
                        </div>
                      }
                      @if (hasSubmitted[request.Id]) {
                        <div class="card-body">
                          <div class="d-flex flex-column align-items-center">
                            <div>
                              <strong>Thank you!</strong>
                            </div>
                            <div>
                              Your request has been submitted.
                            </div>
                            @if (!profile.settings?.transferCreditsShowNewApprovalList) {
                              <div>
                                <button class="btn btn-link" (click)="newRequest(request.Id)">Click here to create a new request</button>
                              </div>
                            }
                          </div>
                        </div>
                      }
